// AdminEventosPage.tsx
import React from 'react';
import { CalendarDays } from 'lucide-react';
import AdminGaleriaPage from './AdminGaleriaPage';

export function AdminEventosPage() {
  // Eventos usam a galeria com pagina='eventos'
  // Por ora redireciona para galeria com filtro de eventos
  return (
    <div className="admin-pagina">
      <div className="admin-pagina-header">
        <div>
          <h1>Eventos</h1>
          <p>Gerencie as fotos e conteúdo dos eventos da LICMAB</p>
        </div>
      </div>
      <div className="admin-aviso">
        <CalendarDays size={32} />
        <div>
          <h3>Galeria de Eventos</h3>
          <p>
            Para publicar fotos de eventos, use a seção <strong>Galeria</strong> e selecione 
            a seção <strong>"Eventos"</strong>. As imagens aparecerão automaticamente na página 
            pública de Eventos.
          </p>
        </div>
      </div>
    </div>
  );
}

// AdminFestejoPage.tsx
export function AdminFestejoPage() {
  return (
    <div className="admin-pagina">
      <div className="admin-pagina-header">
        <div>
          <h1>Festejo Junino</h1>
          <p>Gerencie as fotos e conteúdo do Festejo Junino</p>
        </div>
      </div>
      <div className="admin-aviso">
        <span style={{ fontSize: '2.5rem' }}>🎪</span>
        <div>
          <h3>Galeria do Festejo</h3>
          <p>
            Para publicar fotos do Festejo Junino, use a seção <strong>Galeria</strong> e selecione 
            a seção <strong>"Festejo Junino"</strong>. As imagens aparecerão automaticamente na 
            página pública do Festejo.
          </p>
        </div>
      </div>
    </div>
  );
}

// AdminConfiguracoesPage.tsx
export function AdminConfiguracoesPage() {
  return (
    <div className="admin-pagina">
      <div className="admin-pagina-header">
        <div>
          <h1>Configurações do Site</h1>
          <p>Personalize a aparência do site da LICMAB</p>
        </div>
      </div>

      <div className="config-grid">
        <div className="config-card">
          <h3>🖼️ Imagem de Capa</h3>
          <p>
            A imagem de capa aparece no fundo da página inicial. Para trocar:
          </p>
          <ol>
            <li>Vá em <strong>Galeria</strong></li>
            <li>Clique em <strong>Adicionar Imagem</strong></li>
            <li>Selecione a seção <strong>"Imagem de Capa do Site"</strong></li>
            <li>Faça upload da nova imagem</li>
            <li>A imagem mais recente será usada automaticamente</li>
          </ol>
          <p className="config-dica">
            💡 Dica: use imagens na horizontal (paisagem), preferencialmente 1920x1080px ou maior.
          </p>
        </div>

        <div className="config-card">
          <h3>🏅 Logo da LICMAB</h3>
          <p>
            O logo aparece no hero da página inicial. Para trocar:
          </p>
          <ol>
            <li>Vá em <strong>Galeria</strong></li>
            <li>Clique em <strong>Adicionar Imagem</strong></li>
            <li>Selecione a seção <strong>"Logo da LICMAB"</strong></li>
            <li>Faça upload do novo logo</li>
            <li>O logo mais recente será usado automaticamente</li>
          </ol>
          <p className="config-dica">
            💡 Dica: use imagens PNG com fundo transparente para melhor resultado.
          </p>
        </div>

        <div className="config-card config-card-info">
          <h3>ℹ️ Informações da LICMAB</h3>
          <div className="config-info-lista">
            <div><span>Nome</span><strong>LICMAB — Liga Cultural de Marabá</strong></div>
            <div><span>CNPJ</span><strong>24.603.962/0001-01</strong></div>
            <div><span>Fundação</span><strong>15 de outubro de 2015</strong></div>
            <div><span>Sede</span><strong>Folha 08 Qd 03 Lote 12, Nova Marabá, PA</strong></div>
            <div><span>CEP</span><strong>68.512.390</strong></div>
          </div>
          <p style={{ fontSize: '0.8rem', color: 'var(--cinza)', marginTop: '1rem' }}>
            Para alterar informações institucionais, entre em contato com o desenvolvedor do sistema.
          </p>
        </div>
      </div>
    </div>
  );
}
